import { createActionGroup, emptyProps, props } from '@ngrx/store'

const errorProps = props<{ statusCode: number; errorMsg?: any }>

export const AiArchitectActions = createActionGroup({
  source: 'AiArchitect',
  events: {
    keepOutcome: emptyProps(),
    keepOutcomeSuccess: props<{ duplicateResourceNames: string[] }>(),
    keepOutcomeFailure: errorProps(),
    discardOutcome: emptyProps(),
    discardOutcomeSuccess: emptyProps(),
  },
})
